/* istanbul ignore file */
import axios from 'axios';
import { from } from 'rxjs';
import { map } from 'rxjs/operators';
import moment from 'moment';

const dateLimits = {
  startDate: moment().subtract(6, 'd').startOf('day'),
  endDate: moment().endOf('day')
};

const manageImportMapsData = {
  startDate: moment().subtract(6, 'd').startOf('day'),
  endDate: moment().endOf('day')
};

export function wireImports(payload) {
  const req = {
    ...payload,
    dateLimits
  };
  return from(axios.post('/payments/listWireImports', req)).pipe(map(({ data }) => data));
}

export function manageImportMaps() {
  return from(axios.post('/payments/getImportMaps', manageImportMapsData)).pipe(
    map(({ data }) => data)
  );
}

export function retrieveWireImportMap(payload) {
  return from(axios.post('/payments/retrieveWireImportMap', payload)).pipe(
    map(({ data }) => data)
  );
}

export function deleteWireImportMap(mapId) {
  return from(axios.post('/payments/deleteWireImportMap', mapId)).pipe(map(({ data }) => data));
}

export function deleteACHImportMap(mapCode) {
  return from(axios.post('/payments/deleteACHImportMap', mapCode)).pipe(map(({ data }) => data));
}
